import { all, put, select, takeLatest } from 'typed-redux-saga';
import { getApiParams } from 'api';
import {
	selectPageModelCategoryId,
	selectPageModelRegionId,
	selectPageModelStoreName,
} from 'store/pageModel';
import { InstoreCategory, Store } from './types';
import { instoreActions } from './slice';
import { selectSelectedStoreCode } from './selectors';
import { fetchInstoreCategories, fetchStores } from './api';

export const {
	fetchCategoriesSuccess,
	fetchCategoriesFailed,
	fetchCategoriesRequest,
	fetchStoresFailed,
	fetchStoresRequest,
	fetchStoresSuccess,
	setSelectedStoreData,
} = instoreActions;

export function* instoreRootSaga() {
	return yield all([
		takeLatest(fetchStoresRequest.type, () => getStores()),
		takeLatest(fetchCategoriesRequest.type, () => getInstoreCategories()),
	]);
}

export function* getStores() {
	try {
		const regionCode: string = yield select(selectPageModelRegionId);
		const { url, config } = yield getApiParams(
			'/experience/services-platform/instore-landing/v1/instore-landings/stores'
		);
		const stores: Store[] = yield fetchStores(url, { regionCode }, config);

		// если выбран магазин, заносим в стор данные о нем (для блока выбора магазина)
		const storeCode = yield select(selectSelectedStoreCode);
		const storeName = yield select(selectPageModelStoreName);

		if (storeCode) {
			const { name, address } = stores.filter(({ code }) => code === storeCode)[0];

			yield put(
				setSelectedStoreData({
					data: { name, address, link: storeName },
				})
			);
		}

		yield put(fetchStoresSuccess({ data: stores }));
	} catch (error) {
		yield put(
			fetchStoresFailed({
				error: { code: error?.status || 500, message: error?.message || null },
			})
		);
	}
}

export function* getInstoreCategories() {
	try {
		const currentCategoryId = yield select(selectPageModelCategoryId);
		const { url, config } = yield getApiParams(
			'/experience/services-platform/instore-landing/v1/instore-landings/categories'
		);
		const categories: InstoreCategory[] = yield fetchInstoreCategories(
			url,
			currentCategoryId ? { currentCategoryId } : {},
			config
		);

		yield put(fetchCategoriesSuccess({ data: categories }));
	} catch (error) {
		yield put(
			fetchCategoriesFailed({ error: { code: error?.status || 500, message: error.message } })
		);
	}
}
